export default "__VITE_ASSET__0145a56b__"